<script>

export const defaultFunction = () => {
  return ''
}

// 공백 제거
export const removeWhitespace = text => {
  const regex = /\s/g
  return text.replace(regex, '')
}

// 공백 제거 및 폰번호 변경
export const removeWhitespacePhone = text => {
  const regex = /\s/g
  return text.replace(regex, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
}

// 전화번호형식 확인
export const validatePhone = phone => {
  const regex = /^\d{3}-\d{3,4}-\d{4}$/
  return regex.test(phone)
}

// 영문숫자만
export const validateEngNum = text => {
  const regex = /^[a-zA-Z0-9]*$/
  return regex.test(text)
}

// 숫자만
export const validateNum = text => {
  const regex = /^[0-9]*$/
  return regex.test(text)
}

// 한글영문만
export const validateKorEng = text => {
  const regex = /^[가-힣a-zA-Z]+$/
  return regex.test(text)
}

// 패스워드형식 확인
export const validatePassword = password => {
  // eslint-disable-next-line
  const regex = /^(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/
  return regex.test(password)
}

// email형식 확인
export const validateEmail = email => {
  // eslint-disable-next-line
  const regex = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/
  return regex.test(email)
}

export const getTodayDate = (date_plus = 0) => {
  let now = new Date()
  // eslint-disable-next-line camelcase
  now.setDate(now.getDate() + date_plus)
  let todayYear = now.getFullYear()
  let todayMonth = (now.getMonth() + 1) > 9 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1)
  let todayDate = now.getDate() > 9 ? now.getDate() : '0' + now.getDate()

  return todayYear + '-' + todayMonth + '-' + todayDate
}

export default{
  defaultFunction
}

</script>



// WEBPACK FOOTER //
// src/components/ETC/Validation.vue